// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20iUW","selected":"styles_selected__2B0R9"};